import React, { useState } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import __ from 'utils/i18n';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { fetchResourceRP } from '../../../_shared/fetchResourceRP';
import { getMerchantMe } from '../../_shared/resources';
import { notification } from 'utils/notifications';

export const SessionAccessLinkWidget = () => {
  const { token } = useSelector((state) => state.api);
  const [copied, setCopied] = useState(false);

  const { data } = useQuery({
    queryKey: ['recurringPayments', 'merchantMe'],
    queryFn: () => fetchResourceRP(getMerchantMe(token)),
    enabled: !!token,
    staleTime: 5 * 60 * 1000,
  });

  const sessionRequestUrl = data?.sessionRequestUrl;
  if (!sessionRequestUrl) {
    return null;
  }

  const handleCopy = () => {
    if (copied) return;

    navigator.clipboard.writeText(sessionRequestUrl).then(() => {
      setCopied(true);
      notification.success(
        __('dashboard.sections.recurringPayments.plans.detail.linkCopiedMessage')
      );
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="actions-header">
      <Button
        id="sessionAccessLinkButton"
        className="buttom-radius action__create-item d-flex align-items-center"
        onClick={handleCopy}
        disabled={copied}
      >
        <i className={`mdi mdi-${copied ? 'check' : 'link-variant'} mr-1`} />
        {copied
          ? __('dashboard.sections.recurringPayments.plans.detail.linkCopied')
          : __('dashboard.sections.recurringPayments.plans.actions.sessionAccessLink')}
      </Button>
      <UncontrolledTooltip placement="bottom" target="sessionAccessLinkButton">
        {__('dashboard.sections.recurringPayments.plans.actions.sessionAccessLinkTooltip')}
      </UncontrolledTooltip>
    </div>
  );
};
